var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "box news-box" }, [
      _c(
        "div",
        { staticClass: "sub-nav" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", { attrs: { to: { path: "/" } } }, [
                _vm._v("首页")
              ]),
              _vm._v(" "),
              _c("el-breadcrumb-item", [_vm._v("机构职能")])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "new-wrapper" }, [
        _c(
          "div",
          { staticClass: "left-box fl" },
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                class:
                  _vm.activeIndex == index
                    ? "left-box-title-noSelected active"
                    : "left-box-title-noSelected",
                on: {
                  click: function($event) {
                    return _vm.tab(item, index)
                  }
                }
              },
              [
                _c("div", { staticClass: "left-box-title-main" }, [
                  _c("span", { attrs: { title: item.name } }, [
                    _vm._v(_vm._s(item.name))
                  ])
                ]),
                _vm._v(" "),
                _c("img", {
                  staticClass: "bj",
                  attrs: {
                    src: require("../../assets/images/right.png"),
                    alt: ""
                  }
                })
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-box fn-box fr" }, [
          _c("h2", [_vm._v("职能简介")]),
          _vm._v(" "),
          _vm.list[_vm.activeIndex].briefIntroduction
            ? _c("div", { staticClass: "info" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.list[_vm.activeIndex].briefIntroduction) +
                    "\n        "
                )
              ])
            : _c("div", { staticClass: "info" }, [
                _vm._v("\n            亲，暂无内容哦\n        ")
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "clear" })
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c576a918", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c576a918","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/institutionalFunction/index.vue
// module id = null
// module chunks = 